/**
 * @enum
 * @description - Case State options
 */
export enum CaseStateOptions {
  ALL,
  OPEN,
  CLOSED,
}
